import React, { useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { isAdminUser } from "../utils/roleUtils";
import { getUiChildren } from "../utils/uiConfig";
import { getUiIcon } from "../utils/uiIcons";
import "./SmartToolsHome.css";

function SmartToolsHome() {
  const navigate = useNavigate();
  const { user, uiConfig } = useContext(AuthContext);
  const isAdmin = isAdminUser(user);

  // Direct children of the Smart Tools group in ui_configurations: hubs carry a
  // route of their own and become widget cards; containers (SKU Builders,
  // Reports & Exports, Purchasing) have no page, so they render as a section of
  // their own tools.
  const { widgets, sections } = useMemo(() => {
    const withIcon = (item) => ({ ...item, Icon: getUiIcon(item.icon) });
    const children = getUiChildren(uiConfig, "smart-tools", { isAdmin });
    return {
      widgets: children.filter((item) => item.route).map(withIcon),
      sections: children
        .filter((item) => !item.route && item.children.length > 0)
        .map((item) => ({ ...item, tools: item.children.map(withIcon) })),
    };
  }, [isAdmin, uiConfig]);

  const renderCard = (tool) => {
    const Icon = tool.Icon;
    return (
      <div
        key={tool.id}
        className="tool-card-premium"
        onClick={() => navigate(tool.route)}
        style={{ "--accent-color": tool.accentColor || "#3b82f6" }}
      >
        <div className="tool-icon-circle">
          <Icon />
        </div>
        <div className="tool-info">
          <h3 className="tool-name">{tool.label}</h3>
          <p className="tool-desc">{tool.description}</p>
        </div>
        <div className="tool-arrow">-&gt;</div>
      </div>
    );
  };

  return (
    <div className="tools-wrapper">
      <div className="tools-header-section">
        <h2 className="tools-title-main">Smart Tools</h2>
      </div>

      {widgets.length > 0 && (
        <section className="tools-section">
          <div className="tools-section-header">
            <h3 className="tools-section-title">Widgets</h3>
          </div>
          <div className="tools-grid-container">{widgets.map(renderCard)}</div>
        </section>
      )}

      {sections.map((section) => (
        <section className="tools-section" key={section.id}>
          <div className="tools-section-header">
            <h3 className="tools-section-title">{section.label}</h3>
          </div>
          <div className="tools-grid-container">{section.tools.map(renderCard)}</div>
        </section>
      ))}
    </div>
  );
}

export default SmartToolsHome;
